import { AbstractCustomTableToolsPanel } from "./AbstractCustomTableToolsPanel";
import { PanelProps } from "../../../panel/PanelProps";
import { Table } from "../../Table";

export class CustomCenterTableToolsPanel extends AbstractCustomTableToolsPanel {
    constructor(table: Table, props?: Partial<PanelProps>) {
        super(table, { scrollX: true, ...props })
    }

    override getPopulatedPaddingLeft(): number {
        return 4;
    }

    override getPopulatedPaddingRight(): number {
        return 4;
    }
}
